import { render } from "./ContentsVideos.vue?vue&type=template&id=4ec4c58d&scoped=true"
import script from "./ContentsVideos.vue?vue&type=script&lang=js"
export * from "./ContentsVideos.vue?vue&type=script&lang=js"

import "./ContentsVideos.vue?vue&type=style&index=0&id=4ec4c58d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec4c58d"]])

export default __exports__